<template>
  <base-filter-select
      class="affiliate-select-box"
      v-model="model"
      :options="computedAffiliateOptions"
      label="company"
      :reduce="(affiliate) => affiliate.id"
      :multiple="multiple || selectProps.multiple"
      :clearable="clearable"
      :select-props="selectProps"
      :placeholder="placeholder"
  />
</template>

<script>
import BaseFilterSelect from '@/components/widget/select/BaseFilterSelect.vue';

export default {
  name: 'AffiliateSelectBox',
  components: { BaseFilterSelect },
  props: {
    value: { required: true },
    acronym: { default: () => false },
    multiple: { type: Boolean, default: () => false },
    nullable: { type: Boolean, default: () => true },
    clearable: { type: Boolean, default: () => false },
    selectProps: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: () => false },
    readonly: { type: Boolean, default: () => false },
    placeholder: { type: String, default: () => '' }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    computedAffiliateOptions() {
      const affiliates = this.$store.getters['data/allAffiliates'] || [];
      const enableNullable = this.nullable || this.selectProps.nullable;
      if (enableNullable) {
        return [{ id: null, company: 'NOT ASSIGNED' }, ...affiliates];
      }
      return affiliates;
    },
  },
};
</script>
